<template>
  <div class="msg-item" @click="navigate(detail)">
    <div class="header">
      <div class="module-name" :class="[!detail.isRead ? 'dot' : '']">
        {{ detail.moduleName }}
      </div>
      <div class="time">{{ detail.createTime }}</div>
    </div>
    <div class="body">
      <!-- 适配文本中的/n换行符 -->
      <div
        class="title"
        style="white-space: pre;line-height: 1.5;"
        v-if="detail.content.indexOf('\n') != -1"
        v-html="detail.content"
      ></div>
      <div class="title" style="line-height: 1.5;" v-else>{{ detail.content }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MsgItem",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    navigate(detail) {
      this.$emit("navigate", detail);
    },
  },
};
</script>

<style lang="less" scoped>
.msg-item {
  font-size: 13px;
  background-color: #fff;
  border-radius: 8px;
  line-height: 1.5;
  padding: 12px;
  margin: 10px 15px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999;
    font-weight: 400;
    margin: 12px auto;
    .dot {
      position: relative;
      &::after {
        position: absolute;
        top: -2px;
        right: -8px;
        display: inline-block;
        content: "";
        width: 10px;
        height: 10px;
        border: 2px solid #fff;
        border-radius: 50%;
        background-color: #fe4f54;
      }
    }
  }
  .body {
    .title {
      color: #333;
      font-size: 15px;
      font-weight: 400;
      margin: 12px auto;
    }
    .content {
      color: #999;
      margin: 12px auto;
      .detail {
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 100%;
      }
    }
  }
}
</style>
